import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Reservation, ReservationItem } from 'src/app/model/reservation.model';
import { MatTableDataSource } from '@angular/material';
import { PaymentService } from 'src/app/service/payment.service';
import { DialogService } from 'src/app/service/dialog.service';
import { ReservationService } from 'src/app/service/reservation.service';
import { Location } from '@angular/common';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { TranslationService } from 'src/app/service/translate.service';

@Component({
  selector: 'app-payment-init',
  templateUrl: './payment-init.component.html',
  styleUrls: ['./payment-init.component.css']
})
export class PaymentInitComponent implements OnInit {

  message: string;
  reservation: Reservation;
  hasOrderItems: boolean;
  orderItemsSource = new MatTableDataSource<ReservationItem>();
  orderItemsDisplayedColumns = ['productDescription', 'quantity', 'amount'];
  confirmed: boolean;
  PAYMENT_ADVANCE = 30;
  selectedPaymentOption = 0;
  paymentOptions: any[];
  reservationList : String;

  constructor(
    private router: Router,
    private paymentService: PaymentService,
    private reservationService: ReservationService,
    private dialogService: DialogService,
    private location: Location,
    private translationPipe: TranslationPipe,
    public translationService: TranslationService) {
    this.intiState();
  }

  ngOnInit() {
    this.translationService.currentLang.subscribe(x => this.intiPaymentOptions());
  }

  intiState() {
    if (this.router.getCurrentNavigation().extras.state) {
      this.reservation = this.router.getCurrentNavigation().extras.state.reservation as Reservation;
      this.reservationList=this.router.getCurrentNavigation().extras.state.reservationList as String;
      this.reservationService.createOrderItems(this.reservation).subscribe(res => this.initReservation(res as Reservation));
    }
    // else {
    //   this.reservationService.getByIdWithOrderItems(81).subscribe( res => this.initReservation(res as Reservation));
    // }
  }

  initReservation(res: Reservation) {
    this.reservation = res;
    this.hasOrderItems = this.reservation && this.reservation.reservationItems && this.reservation.reservationItems.length > 0;
    if (this.reservation.amount === 0) {
      this.reservation.amount = this.reservation.reservationItems.map(i => i.amount).reduce((a, b) => a + b, 0);
    }
    this.orderItemsSource.data = this.reservation.reservationItems;
    this.confirmed = this.reservation.id > 0;
    this.intiPaymentOptions();
  }

  intiPaymentOptions() {
    this.paymentOptions = [{ id: 0, description: this.translationPipe.transform('lblPaymentOptionOnRecive')}];
    if (this.reservation && this.reservation.partialPaymentAllowed) {
      this.paymentOptions.push(
        { id: 1, description: `${this.translationPipe.transform('lblPaymentOptionPartOfAmount')}: ${(Math.round(this.reservation.amount * this.PAYMENT_ADVANCE / 100 * 100) / 100).toFixed(2)} RSD)`});
    }

    this.paymentOptions.push(
      { id: 2, description: `${this.translationPipe.transform('lblPaymentOptionFullAmount')}: ${(Math.round(this.reservation.amount * 100) / 100).toFixed(2)} RSD)`});

    return this.paymentOptions;
  }

  confirm() {
    if (this.selectedPaymentOption === 0) {
      this.createReservation(
        this.translationPipe.transform('msgReservationCreated'),
        () => this.router.navigateByUrl('/'));
    } else {
      if (this.selectedPaymentOption === 1) {
        this.reservation.partialPayment = true;
      }
      this.createAndPayReservation();
    }
  }

  createAndPayReservation() {
    this.createReservation(
      this.translationPipe.transform('msgReservationCreatedContinueToPayment'),
      () => this.pay());
  }

  createReservation(msg: string, callback: () => any) {
    if (this.reservation.id == 0) {
      this.reservationService
      .CreateReservation(this.reservation)
      .subscribe(res => {
        this.initReservation(res);
        this.dialogService.showMessageWithCallback(
          this.translationPipe.transform('msgReservationCreatedTitle'),
          msg,
          callback);
      });
    } else {
      callback();
    }
  }

  pay() {
    if (this.reservation != null) {
      this.paymentService.pay(this.reservation).subscribe(
        res => {
          window.location.href = res.hppUrl;
        },
        err => {
          this.dialogService.showMessageWithCallback(
            this.translationPipe.transform('msgPaymentErrorTitle'),
            this.translationPipe.transform('msgPaymentError'),
            () => this.router.navigateByUrl('/')
          );
        }
      );
    }
  }

  cancel() {
   
    if(this.reservationList=='reservationList'){
    this.router.navigateByUrl('/reservation-list', { state: { isLessonReservation: this.reservation.isLessonReservation } });
    }
    else{
      this.location.back();
    }
  }
}
